import {gql} from 'apollo-angular';
import { Group } from '../../entities/group/group';
import { Page } from '../../entities/page/page';

export const GROUPS_QUERY = gql`
query groupsQuery($number: Int, $size: Int, $sortProperty: String, $sortDirection: String)
{
  groups: getGroupsPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    }
  ){
      totalPages
      totalElements
      number
      size
      content{
          id
          name
      }
  }
}
`;

export interface GroupsQueryResponse {
  groups: Page<Group>;
  loading: boolean;
}
